import QiniuUpload from '@/components/QiniuUpload';
import { city } from "@/utils/cascaderArea";
import { Button, Cascader, Col, Form, Icon, Input, Row, Select, Modal } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import { toSave, previewResource, downloadResource } from "@/fetch/api/personal";
import './style.less';
const {
  TextArea
} = Input;
const {
  Option
} = Select;

class CompleteInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: this.props.infoModalData,
      citys: [],
      domain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev.yunduoketang.cn',
      fileName: "",
      fileUrl: "",
      visiblePreview: false
    };
  }

  componentDidMount() {
    this.props.onRef(this);
    this.setState({
      citys: city
    });

    if (this.state.formData.defineDataVos.length > 0) {
      let fileIndex = this.state.formData.defineDataVos.findIndex(item => item.tldType === "file" && item.colValue != null);

      if (fileIndex != -1) {
        axios({
          url: `${this.state.domain}/student/updateBaseInfoAndCustomInfo`,
          method: 'post',
          data: {
            id: this.state.formData.defineDataVos[fileIndex].colValue
          }
        }).then(res => {
          if (res.resource != null && res.resource.delFlag < 1) {
            this.setState({
              fileName: data.resource,
              fileUrl: data.path
            });
          }
        });
      }
    }
  }

  validateData = () => {
    let result;
    this.props.form.validateFieldsAndScroll((err, value) => result = err);
    return result;
  };
  previewCancel = e => {
    this.setState({
      visiblePreview: false
    });
  };
  onPreview = () => {
    previewResource(this.state.fileId, this.state.domain).then(res => {
      if (res.success) {
        this.setState({
          fileUrl: res.data,
          visiblePreview: true
        });
      }
    });
  };
  onDeleteFile = () => {
    this.setState({
      fileName: "",
      fileUrl: ""
    });
    this.props.form.setFieldsValue({
      picture: ""
    });
  };
  downloadFile = () => {
    downloadResource(this.state.fileId, this.state.domain).then(res => {
      if (res.success) {
        window.open(res.data);
      }
    });
  };
  handleFileUploaded = (file, res) => {
    const type = file.name.substring(file.name.lastIndexOf(".") + 1);
    const imgs = ['JPG', 'jpg', 'png', 'gif'];
    const docs = ['doc', 'xls', 'ppt', 'docx', 'xlsx', 'pptx', 'txt'];
    let fileCategory = 'pdf';

    if (imgs.includes(type)) {
      fileCategory = 'image';
    }

    if (docs.includes(type)) {
      fileCategory = 'docs';
    }

    toSave({
      fileName: file.name,
      fileType: type,
      sourcePath: res.key,
      sourceSize: file.size,
      fileCategory,
      uploadType: 0
    }, this.state.domain).then(res => {
      if (res.code === '1') {
        this.setState({
          fileName: file.name,
          fileId: res.data
        });
        this.props.form.setFieldsValue({
          picture: res.data
        });
      }
    }).catch(err => Promise.reject(err));
  };

  render() {
    const {
      state,
      props
    } = this;
    const layout = {
      labelCol: {
        span: 3
      },
      wrapperCol: {
        span: 21
      }
    };
    const {
      getFieldDecorator
    } = this.props.form;
    return <div data-inspector-line="123" data-inspector-column="13" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" className="complete-extend">
      <Form data-inspector-line="124" data-inspector-column="6" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" {...layout} colon={false}>
        <Row data-inspector-line="125" data-inspector-column="8" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" gutter={24}>
          <Col data-inspector-line="126" data-inspector-column="10" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" span={12}>
            <Form.Item data-inspector-line="127" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" labelCol={{
              span: 6
            }} wrapperCol={{
              span: 6
            }} label="姓名">
              {getFieldDecorator('username_check', {
                rules: [{
                  required: true,
                  message: '请输入姓名'
                }],
                initialValue: state.formData.stuInfo.name
              })(<Input data-inspector-line="136" data-inspector-column="19" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" placeholder="请输入姓名" style={{
                width: '200px'
              }} />)}
            </Form.Item>
          </Col>
          {state.formData.isCusCompany && <Col data-inspector-line="141" data-inspector-column="40" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" span={12}>
            <Form.Item data-inspector-line="142" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" labelCol={{
              span: 6
            }} wrapperCol={{
              span: 6
            }} label="证件类型">
              {getFieldDecorator('idenType_check', {
                rules: [{
                  required: true,
                  message: '请选择证件类型'
                }],
                initialValue: state.formData.stuInfo.identityTypeCode
              })(<Select data-inspector-line="151" data-inspector-column="19" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" placeholder="请选择证件类型" onChange={this.onIdenChange} allowClear style={{
                width: '200px'
              }}>
                    <Option data-inspector-line="156" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" value="ID_IDCARD">身份证</Option>
                    <Option data-inspector-line="157" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" value="ID_PASSPORT">护照</Option>
                    <Option data-inspector-line="158" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" value="ID_HMP">港澳通行证</Option>
                    <Option data-inspector-line="159" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" value="ID_TCP">台胞证</Option>
                    <Option data-inspector-line="160" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" value="ID_OFFICERS">军官证</Option>
                    <Option data-inspector-line="161" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" value="ID_SERGEANTS">士官证</Option>
                    <Option data-inspector-line="162" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" value="ID_UNCONFM_ID">未确定证件</Option>
                  </Select>)}
            </Form.Item>
          </Col>}
          {state.formData.isCusCompany && <Col data-inspector-line="166" data-inspector-column="40" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" span={12}>
            <Form.Item data-inspector-line="167" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" labelCol={{
              span: 6
            }} wrapperCol={{
              span: 6
            }} label="证件号">
              {getFieldDecorator('identityId_check', {
                rules: [{
                  required: true,
                  message: "请输入证件号"
                }],
                initialValue: state.formData.stuInfo.identityId
              })(<Input data-inspector-line="176" data-inspector-column="19" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" placeholder="请输入证件号" style={{
                width: '200px'
              }} />)}
            </Form.Item>
          </Col>}
          {state.formData.isExistsCheckStuLocationData > 0 && <Col data-inspector-line="181" data-inspector-column="58" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" span={24}>
            <Form.Item data-inspector-line="182" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" label="地址">
                {getFieldDecorator('citys', {
                rules: [{
                  required: true,
                  message: "请选择地址"
                }],
                initialValue: state.formData.stuInfo.province ? [state.formData.stuInfo.province, state.formData.stuInfo.city, state.formData.stuInfo.county] : []
              })(<Cascader data-inspector-line="188" data-inspector-column="16" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" placeholder="请选择" style={{
                width: 200
              }} fieldNames={{
                value: 'label'
              }} options={state.citys} />)}
            </Form.Item>
          </Col>}
          {state.formData.isExistsCheckStuLocationData > 0 && <Col data-inspector-line="197" data-inspector-column="58" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" span={24}>
            <Form.Item data-inspector-line="198" data-inspector-column="12" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" colon={false} wrapperCol={{
              span: 21,
              offset: 3
            }}>
              {getFieldDecorator('addressDetail_check', {
                initialValue: state.formData.stuInfo.addressDetail
              })(<TextArea data-inspector-line="201" data-inspector-column="110" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" placeholder="请输入详细地址" style={{
                width: 530
              }} />)}
            </Form.Item>
          </Col>}
          {
            /* defineDataVos扩展字段 */
          }
          {state.formData.defineDataVos.length > 0 && state.formData.defineDataVos.map((field, index) => {
            switch (field.tldType) {
              case "text":
                return field.allowModify == 1 && <Col data-inspector-line="212" data-inspector-column="40" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" span={12}>
                    <Form.Item data-inspector-line="213" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" labelCol={{
                    span: 6
                  }} wrapperCol={{
                    span: 6
                  }} key={index} label={field.colComment}>
                      {getFieldDecorator(field.colName, {
                      rules: [{
                        required: field.colAllowNull == 0 ? true : false,
                        validator: (rule, value, callback) => {
                          let val = value ? value : "";

                          if (field.colAllowNull == 0 && val == "") {
                            callback('请输入' + field.colComment);
                          } else if (val.length > 45) {
                            callback("长度不能超过45个字");
                          } else {
                            callback();
                          }
                        }
                      }],
                      initialValue: field.colValue ? field.colValue : field.defaultValue ? field.defaultValue : ''
                    })(<Input data-inspector-line="232" data-inspector-column="25" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" style={{
                      width: 200
                    }} />)}
                    </Form.Item>
                  </Col>;
                break;

              case "select":
                return <Col data-inspector-line="241" data-inspector-column="18" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" span={12}>
                    <Form.Item data-inspector-line="242" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" labelCol={{
                    span: 6
                  }} wrapperCol={{
                    span: 6
                  }} key={index} label={field.colComment}>
                      {getFieldDecorator(field.colName, {
                      rules: field.colAllowNull == 0 ? [{
                        required: true,
                        message: field.colComment
                      }] : [],
                      initialValue: field.colValue ? field.colValue : field.defaultValue ? field.defaultValue : ''
                    })(<Select data-inspector-line="252" data-inspector-column="25" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" style={{
                      width: 200
                    }}>
                        {field.itemsData.map(item => <Option data-inspector-line="254" data-inspector-column="26" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" value={item.key} key={item.id}>{item.key}</Option>)}
                      </Select>)}
                    </Form.Item>
                  </Col>;
                break;

              case "file":
                return field.allowModify == 1 && <Col data-inspector-line="263" data-inspector-column="40" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" span={24}>
                    <Form.Item data-inspector-line="264" data-inspector-column="20" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" key={index} label={field.colComment}>
                      {getFieldDecorator('picture', {
                      rules: field.colAllowNull == 0 ? [{
                        required: true,
                        message: field.colComment
                      }] : [],
                      initialValue: field.colValue
                    })(state.fileName ? <div data-inspector-line="272" data-inspector-column="40" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" className="file-uploaded">
                          <div data-inspector-line="273" data-inspector-column="26" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" className="file-handle">
                            <span data-inspector-line="274" data-inspector-column="28" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" className="file-name change-font-color" onClick={this.onPreview}>{state.fileName}</span>
                            <i data-inspector-line="275" data-inspector-column="28" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" className="iconfont iconguanbi1" onClick={this.onDeleteFile}></i>
                            <span data-inspector-line="276" data-inspector-column="28" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" className="file-download change-font-color" onClick={this.downloadFile}>下载</span>
                          </div>
                          <QiniuUpload data-inspector-line="278" data-inspector-column="26" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" id="personalDataUploadFile" children={<Button data-inspector-line="280" data-inspector-column="38" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" type="primary"><Icon data-inspector-line="280" data-inspector-column="61" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" type="upload" />重新上传</Button>} handleFileUploaded={this.handleFileUploaded} />
                        </div> : <QiniuUpload data-inspector-line="284" data-inspector-column="24" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" id="personalDataUploadFile" children={<Button data-inspector-line="286" data-inspector-column="34" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" type="primary"><Icon data-inspector-line="286" data-inspector-column="57" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" type="upload" />上传附件</Button>} handleFileUploaded={this.handleFileUploaded} />)}
                      <p data-inspector-line="290" data-inspector-column="22" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" className="upload-type">支持附件类型：txt，ppt，docx，xlsx，pptx，jpg，png，gif</p>
                    </Form.Item>
                  </Col>;

              default:
                break;
            }
          })}
        </Row>
      </Form>
      <Modal data-inspector-line="300" data-inspector-column="6" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" visible={this.state.visiblePreview} footer={null} onCancel={this.previewCancel}>
        <img data-inspector-line="305" data-inspector-column="8" data-inspector-relative-path="src\\containers\\PersonalCenter\\CourseCenter\\Components\\LiveRoom\\CompleteInfo.jsx" src={this.state.fileUrl} style={{
          width: "100%"
        }} />
      </Modal>
    </div>;
  }

}

export default Form.create()(CompleteInfo);